<template>
	<div>
		<h1>Mandanten-Parameter</h1>
		<strong>Mandant:</strong> {{ clientName }} <button class="btnSync" @click="clientParamSync" :disabled="disableSync"><i class="fas fa-sync"></i> Daten synchronisieren</button><br>
		<button @click="showAccounts" :class="show.accounts ? 'btnActive' : ''">Fibu-Konten</button> <button @click="showVAT" :class="show.vat ? 'btnActive' : ''">MWST-Codes</button> <button @click="showCurrencies" :class="show.currencies ? 'btnActive' : ''">Währungen</button>

		<table v-if="show.accounts">
			<thead>
				<th class="center">Kto.Nr.</th>
				<th>Bezeichnung</th>
				<th class="center">Typ</th>
				<th class="center">Währung</th>
				<th class="center">MWST</th>
			</thead>
			<tbody>
				<tr v-for="(rec,idx) in acct_recs" :key="idx">
					<td class="center">{{ rec.number }}</td>
					<td>{{ rec.description }}</td>
					<td class="center"><span class="badge" :class="{ aktiven: rec.type === 'ASSETS', passiven: rec.type === 'LIABILITIES', ertrag: rec.type === 'REVENUE', aufwand: rec.type === 'EXPENSES', abschluss: rec.type === 'CLOSING' }">{{ rec.type | translateAcctType }}</span></td>
					<td class="center">{{ rec.currency }}</td>
					<td class="center">{{ rec.vat_code }}</td>
				</tr>
			</tbody>
		</table>
		<table v-if="show.vat">
			<thead>
				<th class="center">Code</th>
				<th>Bezeichnung</th>
				<th class="center">%</th>
				<th class="center">Quote</th>
				<th class="center">Netto</th>
				<th class="center">UST</th>
			</thead>
			<tbody>
				<tr v-for="(rec,idx) in vat_recs" :key="idx">
					<td class="center">{{ rec.code }}</td>
					<td>{{ rec.description }}</td>
					<td class="center">{{ rec.rate | multiply100 }}</td>
					<td class="center">{{ rec.quote }}</td>
					<td class="center" v-html="formatBoolean(rec.net)"></td>
					<td class="center" v-html="formatBoolean(rec.outtax)"></td>
				</tr>
			</tbody>
		</table>
		<table v-if="show.currencies">
			<thead>
				<th class="center">Währungscode</th>
				<th>Bezeichnung</th>
				<th class="center">Hauptwährung</th>
			</thead>
			<tbody>
				<tr v-for="(rec,idx) in ccy_recs" :key="idx">
					<td class="center">{{ rec.iso_code }}</td>
					<td>{{ rec.description }}</td>
					<td class="center" v-html="formatBoolean(rec.local)"></td>
				</tr>
			</tbody>
		</table>

		<vue-snotify></vue-snotify>
	</div>
</template>

<script>
  import ApiComm from '../../apicomm.js'
  import axios from 'axios'

  export default {
    components: {},
    mixins: [ApiComm],
	data() {
		return {
			id: 0,
			clientName: '',
			disableSync: false,
			show: {
				accounts: false,
				vat: false,
				currencies: false
			},
			search_txt: '',
			acct_recs: [],
			vat_recs: [],
			ccy_recs: []
		}
	},
    methods: {
      showAccounts: function () {
		  this.show.accounts = true
		  this.show.vat = false
		  this.show.currencies = false
		  this.apiCall([{method: 'client/param/account/list', param: {client_id: this.id}, id: 10}], this.evalApiResponse)
	  },
      showVAT: function () {
		  this.show.accounts = false
		  this.show.vat = true
		  this.show.currencies = false
		  this.apiCall([{method: 'client/param/vat/list', param: {client_id: this.id}, id: 20}], this.evalApiResponse)
	  },
      showCurrencies: function () {
		  this.show.accounts = false
		  this.show.vat = false
		  this.show.currencies = true
		  this.apiCall([{method: 'client/param/currency/list', param: {client_id: this.id}, id: 30}], this.evalApiResponse)
	  },
      formatBoolean: function (val) {
		  return val == '1' ? '<i class="far fa-check-square"></i>' : '<i class="far fa-square"></i>'
	  },
      clientParamSync: function () {
		this.disableSync = true
		this.apiCall([{method: 'client/param/sync', param: {client_id: this.id}, id: 99}], this.evalApiResponse)
	  },
      evalApiResponse: function (resp) {
        var vm = this
        this.$_.forEach(resp, function (value) {
          if (value.hasOwnProperty('id')) {
            switch (value.id) {
              case 7: // 7 = Result from '.../load'
                if (value.hasOwnProperty('error')) {
                } else {
                  if (value.hasOwnProperty('result') && value.result.hasOwnProperty('name')) {
                    vm.clientName = value.result.name
                  }
                }
                break
              case 10: // 10 = Result from 'client/param/account/list'
                if (value.hasOwnProperty('error')) {
					vm.$snotify.error(value.error.message, 'ERROR', {timeout: 8000})
                } else {
                    vm.acct_recs = value.result
                }
                break
              case 20: // 20 = Result from 'client/param/vat/list'
                if (value.hasOwnProperty('error')) {
					vm.$snotify.error(value.error.message, 'ERROR', {timeout: 8000})
                } else {
                    vm.vat_recs = value.result
                }
                break
              case 30: // 30 = Result from 'client/param/currency/list'
                if (value.hasOwnProperty('error')) {
					vm.$snotify.error(value.error.message, 'ERROR', {timeout: 8000})
                } else {
                    vm.ccy_recs = value.result
                }
                break
              case 99: // 99 = Result from 'client/param/sync'
                if (value.hasOwnProperty('error')) {
					vm.$snotify.error(value.error.message, 'ERROR', {timeout: 8000})
                } else {
					vm.$snotify.success('Die Daten wurden synchronisiert', 'OK')
                }
                vm.disableSync = false
                break
            }
          }
        })
      }
    },
    filters: {
		multiply100: function (val) {
			return (parseFloat(val) * 100).toFixed(2)
		},
		translateAcctType: function (val) {
		  switch(val) {
			  case 'ASSETS': return 'AKTIVEN'
			  case 'LIABILITIES': return 'PASSIVEN'
			  case 'REVENUE': return 'ERTRAG'
			  case 'EXPENSES': return 'AUFWAND'
			  case 'CLOSING': return 'ABSCHLUSS'
		  }
		}
	},
    mounted: function () {
//		console.log('greetings from mounted')
		this.id = this.$route.params.id
		this.apiCall([{method: 'client/load', param: {id: this.id}, id: 7}], this.evalApiResponse)
    }
  }
</script>

<style scoped="">
button {
	border: 1px solid #000;
	background: #888;
	color: #fff;
	margin-bottom: 20px;
	margin-right: 2px;
	padding: 5px 10px;
	cursor: pointer;
	font-weight: 700;
}

button:hover {
	background: #666;
}

table {
	border-collapse: collapse;
	border: 1px solid #888;
	margin-bottom: 20px;
}

th {
	background: #317dff;
	color: #fff;
	padding: 10px 10px;
	min-width: 30px;
	text-align: left;
	border-bottom: 1px solid #888;
}

td {
	color: #333;
	padding: 10px 10px;
	text-align: left;
}

.center {text-align: center}

tr:nth-child(even) {background: #eee}
tr:nth-child(odd) {background: #fff}

td > i {
	cursor: pointer;
}

.badge {
	border-radius: 5px;
	padding: 3px 5px;
	color: #fff;
}

.badge.aktiven {
	background: #080;
}

.badge.passiven {
	background: #c00;
}

.badge.ertrag {
	background: #f38000;
}

.badge.aufwand {
	background: #bf22d7;
}

.badge.abschluss {
	background: #888;
}

/* CONFIRM DELETION*/
.delConf-title {
	cursor: move;
	font-weight: 700;
	line-height: 40px;
	border-bottom: 1px solid #aaa;
	padding: 0 10px;
}

.delConf-content {
	padding: 20px 10px;
}

.delConf-button-wrapper {
	border-top: 1px solid #aaa;
	padding: 10px 10px 0 10px;
}

.delConf-button-wrapper button {
	margin-left: 5px;
}

.delConf-btn-del {
	background: #c00;
}

.delConf-btn-del:hover {
	background: #a00;
}

/*EDIT DIALOG*/
.delConf-content label {
	display: inline-block;
	width: 200px;
}

.delConf-content input[type=text], .delConf-content select {
	width: 250px;
	border: 1px solid #888;
	margin-bottom: 5px;
	padding:3px;
	background: #fff;
}

hr {
    border: none;
    height: 1px;
    color: #333; /* old IE */
    background-color: #333; /* Modern Browsers */
}

.left_space {
	margin-left: 30px;
}

.btnSync {
	font-size:12px;
	background: #800;
}
.btnSync i {
	margin-right:5px;
}

.btnActive {
	background: #008bff;
}
</style>
